import indigo from "@mui/material/colors/indigo";
import red from "@mui/material/colors/red";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Profile from "./profile";

import grey from "@mui/material/colors/grey";
import teal from "@mui/material/colors/teal";
import log from "loglevel";
import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AdvertisingHome, { AdvListView } from "./advertising/AdvertisingHome";
import { Paths } from "./common/navigation";
import Contact from "./contact/Contact";
import { default as Films } from "./film/Films";
import Main from "./global/Main";
import { Login, SSOReturn } from "./login";
import { actions } from "./login/logic/actions";
import { AdvReport } from "./report/advertising/container";
import { LogReport } from "./report/logsheet/container";
import { default as Report } from "./report/Report";
import ApiImportSetting from "./settings/apiImport";
import TagSettings from "./settings/tags";
import TemplateSettings from "./settings/templates";
import UserSetting from "./settings/user";
import Form from "./settings/user/form";
import List from "./settings/user/list";

import {ReviewUser, default as StatisticsHome, Tags, FilmReleaseStatistics} from "./statistics/container";

import AdvDetails from "./advertising/AdvDetails";
import Logout from "./login/Logout";
import { StyledEngineProvider } from "@mui/material/styles";

export const theme = createTheme({
    palette: {
        mode: "light",
        primary: teal,
        secondary: indigo,
        red: red,
        default: {
            main: grey[300],
            dark: grey[400],
        },
        error: {
            main: red[600],
        },
        customColor: {
            main: "#fff",
            light: "#fff",
        },
        background: {
            default: "#fafafa"
        }
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    overflow: "unset",
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                colorDefault: {
                    color: "rgba(0, 0, 0, 0.87)",
                    borderColor: "rgba(0, 0, 0, 0.23)",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                outlined: {
                    color: "rgba(0, 0, 0, 0.87)",
                    borderColor: "rgba(0, 0, 0, 0.23)",
                    "&:hover": {
                        borderColor: "rgba(0, 0, 0, 0.30)",
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                    },
                },
                outlinedSecondary: {
                    color: teal[500],
                    borderColor: teal[400],
                    "&:hover": {
                        backgroundColor: teal[50],
                    },
                },
            },
        },
        MuiContainer: {
            styleOverrides: {
                maxWidthXl: {
                    maxWidth: "1920px !important",
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    paddingBottom: "8px",
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    maxHeight: 38,
                },

                multiline: {
                    maxHeight: "unset",
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    maxHeight: 20,
                    top: -10,

                    "&[data-shrink='true']": {
                        top: 0,
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    width: "100%",
                },
            },
        },
        MuiExpansionPanelSummary: {
            styleOverrides: {
                root: {
                    "&.Mui-expanded": {
                        minHeight: "45px",
                    },
                },
                content: {
                    width: "100%",
                    "&.Mui-expanded": {
                        margin: "5px 0",
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    color: "#fff !important",
                    backgroundColor: "#009688 !important",
                },
            },
        },
    },
    spacing: (factor) => `${0.25 * factor}rem`,
});
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }
    componentDidCatch(error, info) {
        this.setState({ hasError: true });
        log.error(error, info);
    }
    componentDidMount() {
        this.props.onLoadCredentials(this.props.authenticated);
    }
    render() {
        return (
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <StyledEngineProvider injectFirst>
                        <AppView />
                    </StyledEngineProvider>
                </BrowserRouter>
            </ThemeProvider>
        );
    }
}

const AppView = () => {
    return (
        <Routes>
            <Route path={Paths.LOGIN} element={<Login />} />
            <Route path={Paths.LOGINSSORETURN} element={<SSOReturn />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/" element={<Main />}>
                <Route path="/" index element={<Navigate to={Paths.ADVERTISING} />} />
                <Route path={Paths.ADVERTISING} element={<AdvertisingHome />}>
                    <Route index path={""} element={<AdvListView />} />

                    <Route path={":id"} element={<AdvDetails />} />
                </Route>
                <Route path={Paths.CONTACT} element={<Contact />} />
                <Route path={Paths.REPORT} element={<Report />}>
                    <Route path={Paths.ADV_REPORT} element={<AdvReport />} />
                    <Route path={Paths.LOG_REPORT} element={<LogReport />} />
                </Route>

                <Route path={Paths.FILM} element={<Films />} />
                <Route path={Paths.PROFILE} element={<Profile />} />

                <Route path={Paths.STATISTICS} element={<StatisticsHome />}>
                    <Route path={Paths.STATISTICS_USER} element={<ReviewUser />} />
                    <Route path={Paths.STATISTICS_CATEGORIES} element={<FilmReleaseStatistics />} />
                    <Route path={Paths.STATISTICS_TAGS} element={<Tags />} />
                </Route>

                <Route path={Paths.ADMIN_TAGS} element={<TagSettings />} />
                <Route path={Paths.ADMIN_API_IMPORT} element={<ApiImportSetting />} />

                <Route path={Paths.ADMIN_TEMPLATES} element={<TemplateSettings />} />

                <Route path={Paths.ADMIN_USER} lazy={<UserSetting />}>
                    <Route exact path={Paths.ADMIN_USER} element={<List />} />

                    <Route path={Paths.ADMIN_USER_EDIT} element={<Form />} />
                </Route>
            </Route>
        </Routes>
    );
};
function mapStateToProps(state) {
    return {
        authenticated: state.login.authenticated,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onLoadCredentials: (authenticated) => dispatch(actions.ON_LOAD_CREDENTIALS.send({ authenticated })),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(App);
